export const vehicleHeaderTable: string[] = ["Placa", "Modelo", "Ano", "Capacidade", "Restrição"]

export const mock = [
    {
        plate: "KID4",
        model: "FIAT UNO",
        year: 2010,
        capacity: 1.234,
        bodyWorkSize: 12,
        restrictions: "São paulino"
    },
    {
        plate: "CMD12",
        model: "CORSA",
        year: 1998,
        capacity: 1.234,
        bodyWorkSize: 12,
        restrictions: "São paulino"
    },
    {
        plate: "JH12",
        model: "NISSAN GTR",
        year: 2022,
        capacity: 1.234,
        bodyWorkSize: 12,
        restrictions: "São paulino"
    },
    {
        plate: "PRT",
        model: "skyle UNO",
        year: 2014,
        capacity: 1.234,
        bodyWorkSize: 12,
        restrictions: "São paulino"
    },
]